import apiClient from '@/services/apiClient';

/**
 * Obtiene todas las ofertas
 */
export const getOffers = async (params = {}) => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.get(`/marketing/offers/`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params
  });
  // Manejar tanto el caso donde la respuesta es un objeto con 'results'
  // como el caso donde la respuesta es directamente una lista de ofertas
  return response.data.results ? response.data : { results: response.data };
};

/**
 * Obtiene una oferta por su ID
 */
export const getOffer = async (id) => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.get(`/marketing/offers/${id}/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

/**
 * Crea una nueva oferta
 */
export const createOffer = async (offerData) => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.post(`/marketing/offers/`, offerData, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

/**
 * Actualiza una oferta existente
 */
export const updateOffer = async (id, offerData) => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.put(`/marketing/offers/${id}/`, offerData, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

/**
 * Elimina una oferta
 */
export const deleteOffer = async (id) => {
  const token = localStorage.getItem('accessToken');
  await apiClient.delete(`/marketing/offers/${id}/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return true;
};
